import { render } from "./AsrCreatePickCallLegacy.vue?vue&type=template&id=ea96a522&scoped=true"
import script from "./AsrCreatePickCallLegacy.vue?vue&type=script&lang=js"
export * from "./AsrCreatePickCallLegacy.vue?vue&type=script&lang=js"

import "./AsrCreatePickCallLegacy.vue?vue&type=style&index=0&id=ea96a522&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea96a522"]])

export default __exports__
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLinearProgress,QBtn});
